import { Box } from "@mui/material";
import { SOCIAL } from "../constants";

import discordLogo from "../assets/social/discord.svg";
import openseaLogo from "../assets/social/opensea.svg";
import instagramLogo from "../assets/social/instagram.svg";
import twitterLogo from "../assets/social/twitter.png";

const SocialLinks = () => {
  return (
    <Box
      display={"flex"}
      justifyContent={"center"}
      sx={{
        marginTop: "30px",
      }}
    >
      <a
        href={SOCIAL["discord"]}
        target="_blank"
        rel="noopener noreferrer"
        style={{ pointerEvents: SOCIAL["discord"] ? "auto" : "none" }}
      >
        <img src={discordLogo} alt="discord" className="social-logo" />
      </a>

      <a
        href={SOCIAL["twitter"]}
        target="_blank"
        rel="noopener noreferrer"
        style={{ pointerEvents: SOCIAL["twitter"] ? "auto" : "none" }}
      >
        <img src={twitterLogo} alt="twitter" className="social-logo" />
      </a>

      <a
        href={SOCIAL["instagram"]}
        target="_blank"
        rel="noopener noreferrer"
        style={{ pointerEvents: SOCIAL["instagram"] ? "auto" : "none" }}
      >
        <img src={instagramLogo} alt="instagram" className="social-logo" />
      </a>

      <a
        href={SOCIAL["opensea"]}
        target="_blank"
        rel="noopener noreferrer"
        style={{ pointerEvents: SOCIAL["opensea"] ? "auto" : "none" }}
      >
        <img src={openseaLogo} alt="opensea" className="social-logo" />
      </a>
    </Box>
  );
};

export default SocialLinks;
